var map = {
	"./1.png": 9478,
	"./2.png": 685,
	"./3.png": 4004,
	"./4.png": 3915,
	"./5.png": 2786,
	"./6.png": 8873,
	"./7.png": 2624,
	"./8.png": 2535,
	"./9.png": 6958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8447;